import React, { useEffect, useState } from "react";
import styles from "./TestCanvas.module.scss";
import ProductItem from "../store-front/components/product-item/ProductItem";
import NewDealProductItem from "../store-front/components/new-deal-item/NewDealProductItem";
import NewDeals from "../store-front/components/new-deals/NewDeals";
import ProductImagesSwiper from "../store-front/components/product-images-swiper/ProductImagesSwiper";
import PaymentOptions, { PaymentOption } from "../../common/components/payment-options/PaymentOptions";
import { CustomerPaystackCard } from "../../model/customer/customer";

type Props = {};

const TestCanvas: React.FC<Props> = (props: Props) => {
	const [selectedOption, setSelectedOption] = useState<PaymentOption>("wallet");

	const [selectedCardId, setSelectedCardId] = useState<CustomerPaystackCard | undefined>(undefined);

	return (
		<div className={styles.container}>
			{/* <ProductItem /> */}
			{/* <NewDeals /> */}
			{/* <ProductImagesSwiper /> */}
			<PaymentOptions
				selectedOption={selectedOption}
				onSelectPaymentOption={option => {
					setSelectedOption(option);
				}}
				selectedCard={selectedCardId}
				onSelectedCard={card => {
					setSelectedCardId(card);
				}}
			/>
		</div>
	);
};

export default TestCanvas;
